<div class="blog-profile-holder">
  <div class="top-div">
    <div class="top-div-title">فعالیت ها</div>
  </div>
  <div class="back-holder" (click)="closeActivity()">
    <img src="assets/general/back-blue.svg" />
  </div>
  <div class="page-holder" *ngIf="dataIsReady">
    <div
      *ngIf="followRequestsCount !== 0"
      class="follow-requests-holder"
      (click)="openRequests()"
    >
      <img
        *ngIf="followRequests[0].avatarPath !== ''"
        src="{{ followRequests[0].avatarPath }}"
        onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
        class="activity-img"
      />
      <img
        *ngIf="followRequests[0].avatarPath === ''"
        src="assets/blog/avatar.svg"
        class="activity-img"
      />
      <div class="follow-requests-badge">{{ followRequestsCount }}</div>
      <div class="follow-requests-title">لیست درخواست‌ها</div>
    </div>
    <div
      *ngFor="let activity of activities; let i = index"
      class="activity-box"
      [ngStyle]="{
        'margin-top': i === 0 && followRequestsCount === 0 ? '16px' : '0'
      }"
    >
      <img
        *ngIf="activity.user.avatarPath !== ''"
        src="{{ activity.user.avatarPath }}"
        onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
        class="activity-img"
        (click)="profile(activity.user.userName)"
      />
      <img
        *ngIf="activity.user.avatarPath === ''"
        src="assets/blog/avatar.svg"
        class="activity-img"
        (click)="profile(activity.user.userName)"
      />
      <div
        *ngIf="activity.entity !== 'FOLLOW_REQUEST'"
        class="activity-text-span"
        (click)="showActivity(activity)"
      >
        <div class="activity-username">{{ activity.user.userName }}</div>
        <div class="activity-fake-text">‌ل‌</div>
        {{ activity.text }}
      </div>
      <div
        *ngIf="activity.entity !== 'FOLLOW_REQUEST'"
        class="activity-date-label"
      >
        {{ dateHelper.getPostTimeLabel(activity.createdAt) }}
      </div>
      <div
        *ngIf="activity.entity === 'FOLLOW_REQUEST'"
        class="request-username"
        (click)="profile(activity.user.userName)"
      >
        {{ activity.user.userName }}
      </div>
      <div
        *ngIf="activity.entity === 'FOLLOW_REQUEST'"
        class="accept-request"
        (click)="acceptFollowing(activity.user.id)"
      >
        قبول
      </div>
      <div
        *ngIf="activity.entity === 'FOLLOW_REQUEST'"
        class="decline-request"
        (click)="rejectFollowing(activity.user.id)"
      >
        حذف
      </div>
    </div>
    <div
      class="more-activities"
      *ngIf="activitiesCount > (activitiesPage + 1) * activitiesPerPage"
    >
      <div class="more-activities-title" (click)="showMoreActivities()">
        فعالیت‌های بیشتر
      </div>
    </div>
    <div *ngIf="activities.length === 0" class="empty-activity">
      فعالیتی موجود نیست
    </div>
  </div>
  
  <div class="profile-page" id="followRequests" *ngIf="showRequests">
    <app-blog-follow-requests
      [id]="requestsId"
      [requests]="followRequests"
      style="width: 100%; height: 100%"
    ></app-blog-follow-requests>
    <div class="blog-back-holder" (click)="closeRequests()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
 
</div>
